<template>
  <div class="practicalexam">
    <div class="Right">
      <div class="title">
        <span>{{testlist.title}}</span>
        <button @click="tocourse">返回课程主页</button>
      </div>
      <div class="content">
        <div
          class="test"
          v-if="testlist"
        >
           {{testlist.operationInfo}}
        </div>
         <a-empty
      v-else
      description="暂无内容"
    />
      </div>
    </div>
  </div>
</template>

<script>
import { getprexamApi ,getupdateStatusApi} from "@/request/api";
export default {
  name: "practicalexam",
  data() {
    return {
      testId: "",
      list: [],
      munelist: [],
      currentId: "",
      paperId: "",
      menulistId: "",
      testlist: "",
      key: "",
      iv: "",
      chapterId:''
    };
  },
  created() {
    this.paperId = this.$route.query.paperId;
    this.testId = this.$route.query.id;
    this.menulistId = this.$route.query.menuId;
    this.chapterId=this.$route.query.chapterId;
    this.init();
  },
  methods: {
    init() {
       this.getToken(getupdateStatusApi,{"status":1,"courseId":this.testId,"taskId":this.menulistId},()=>{
          this.$store.commit('getIds',{'chapterId':this.chapterId,'taskId':this.menulistId})
        })
      // this.getToken(getcourseDetailApi, { courseId: this.testId }, (res) => {
      //   this.list = res.data;
      //   // console.log(this.list.title)
      //   this.munelist = res.data.chapters;
      // });
      // this.getToken(getcatalogApi, { taskId: this.menulistId }, (res) => {
      //   // this.info=res.data
      //   this.resourceUrl = res.data.resourceUrl;
      //   this.currentId = this.menulistId;
      // });
      this.getToken(
        getprexamApi,
        { taskId: this.menulistId },
        (res) => {
          this.testlist=res.data
        }
      );
    },
    tocourse() {
      this.$router.push({ path: "/catalogDetail", query: { id: this.testId,'menuId': this.menulistId,"paperId":this.paperId} });
    },
    getDetail(menuId, type, title, testInfo, paperId, id) {
      this.$router.push({
        path: "/catalogDetail",
        query: { menuId, type, title, testInfo, paperId, id },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.practicalexam {
  border-top: 1px solid #ccc;
  background:#eee;
  .Right {
    margin-top:30px;
    background: #fff;
    width:1205px;
    margin:0 auto;
    .title {
      height: 65px;
      border-bottom: 1px solid #eee;
      margin-left: 38px;
      margin-right: 39px;
      display: flex;
      position: relative;

      span {
        color: #333333;
        font-size: 18px;
        padding-top: 30px;
      }

      button {
        border: 0;
        outline: none;
        width: 99px;
        height: 30px;
        background-color: #ffffff;
        border: solid 1px #cecece;
        color: #4182fa;
        font-size: 12px;
        position: absolute;
        right: 17px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .content {
      margin: 0 auto;
      margin-top: 24px;
      margin-left: 33px;
      margin-right: 120px;
      overflow: hidden;
      min-height: 600px;
      .tit {
        margin: 0 auto;

        h2 {
          font-size: 18px;
          margin: 0 auto;
          text-align: center;
          height: 40px;
          font-weight: bold;
          line-height: 40px;
        }
      }

      .test {
        padding-top: 20px;
        line-height: 24px;
        font-size: 16px;
        text-indent: 20px;
        color: #333;
      }
    }
  }
}
</style>
